export default __webpack_public_path__ + "static/media/game-dog.a2017da5.gif";